import React from 'react'

import { Button } from 'components/UI'

import getAvatarUrl from '../../helpers/getAvatarUrl'

import { MAX_UPLOADED_IMAGES } from 'constants/upload'

import Trash from 'assets/icon/trash.svg'
import ImageNotFill from 'assets/icon/image-not-fill.svg'

const Preview = ({ items, onChange, type }) => {
  const removeVideo = () => {
    onChange([])
  }

  const removeImage = (index) => {
    const _items = [...items]
    _items.splice(index, 1)
    onChange(_items)
  }

  const generateImage = (index) => {
    const isImageAvailable = items.length - 1 >= index
    const item = items[index]

    return isImageAvailable ? (
      <div
        key={index}
        className="group/image relative bg-white flex justify-center items-center w-full aspect-[1/.75] rounded-4 overflow-hidden"
      >
        {item.original ? (
          <img
            src={getAvatarUrl(item.original)}
            alt="Image thumb"
            className="h-full w-full object-cover"
          />
        ) : (
          item.preview && (
            <img src={item.preview} alt="Image thumb" className="h-full w-full object-cover" />
          )
        )}

        <Button
          type="button"
          className="bg-[#F79009] absolute z-[1] p-2 w-[30px] h-[30px] !rounded-full opacity-0 ease duration-200 transition-opacity group-hover/image:!opacity-100"
          onClick={() => removeImage(index)}
        >
          <img src={Trash} alt="Remove thumb" className="max-h-full object-contain" />
        </Button>
      </div>
    ) : (
      <div
        key={index}
        className="group relative bg-[#F9DFCD] flex justify-center items-center w-full aspect-[1/.75] border !border-dashed !border-[#F79009] rounded-4"
      >
        <img src={ImageNotFill} alt="image-thumb" className="max-h-full object-contain" />
      </div>
    )
  }

  const video = items[0]

  const videoSrc = video?.preview || (video && typeof video === 'string' ? video : '')

  return type === 'video' ? (
    <div className="h-full flex flex-col">
      <video src={videoSrc} controls className="flex-1 w-full rounded-2"></video>

      <div className="flex items-center mt-1 justify-between">
        <p className="text-sm text-[#F67443]">{video.name}</p>

        <Button
          type="button"
          className="bg-transparent !text-[#F67443] text-sm flex items-center gap-2"
          onClick={removeVideo}
        >
          <svg
            width="18"
            height="19"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.73057 5.01081H12.5908V13.8347C12.5908 14.0148 12.5193 14.1874 12.392 14.3147C12.2647 14.442 12.092 14.5135 11.912 14.5135H2.40934C2.22932 14.5135 2.05667 14.442 1.92938 14.3147C1.80209 14.1874 1.73057 14.0148 1.73057 13.8347V5.01081ZM3.0881 6.36834V13.156H11.2333V6.36834H3.0881ZM5.12439 7.72587H6.48192V11.7984H5.12439V7.72587ZM7.83945 7.72587H9.19697V11.7984H7.83945V7.72587ZM3.76686 2.97452V1.617C3.76686 1.43698 3.83838 1.26433 3.96567 1.13704C4.09296 1.00974 4.26561 0.938232 4.44563 0.938232H9.87574C10.0558 0.938232 10.2284 1.00974 10.3557 1.13704C10.483 1.26433 10.5545 1.43698 10.5545 1.617V2.97452H13.9483V4.33205H0.373047V2.97452H3.76686ZM5.12439 2.29576V2.97452H9.19697V2.29576H5.12439Z"
              fill="#F67443"
            />
          </svg>
        </Button>
      </div>
    </div>
  ) : (
    <div
      style={{ gridTemplateColumns: `repeat(${MAX_UPLOADED_IMAGES}, minmax(0, 1fr))` }}
      className="grid gap-3 mt-2"
    >
      {[]
        .constructor(MAX_UPLOADED_IMAGES)
        .fill(null)
        .map((_, index) => generateImage(index))}
    </div>
  )
}

export default Preview
